var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c(
        "div",
        {
          class: {
            "spinner--overlay": _vm.overlay,
            "d-inline-block": _vm.inline,
            [`spinner--${_vm.theme}`]: true,
          },
          style: { "--opacity": _vm.opacity },
        },
        [_vm._m(0), _vm._v(" "), _vm._t("loading-text")],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sk-spinner sk-spinner-circle" }, [
      _c("div", { staticClass: "sk-circle1 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle2 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle3 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle4 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle5 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle6 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle7 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle8 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle9 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle10 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle11 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle12 sk-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }